<div class="container-fluid">
  <div class="report-header">
    <div>
      <h1 class="report-title">SLA de Produção</h1>
      <p class="report-subtitle">Entregas no prazo, atrasos e gargalos por etapa.</p>
    </div>
  </div>

  <div class="panel report-filters">
    <div class="report-filters__grid">
      <div class="filter-field">
        <label for="filterStart">Período (início)</label>
        <input
          id="filterStart"
          type="date"
          class="form-control"
          [(ngModel)]="filterStart"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterEnd">Período (fim)</label>
        <input
          id="filterEnd"
          type="date"
          class="form-control"
          [(ngModel)]="filterEnd"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterSeguradora">Seguradora</label>
        <select
          id="filterSeguradora"
          class="form-control"
          [(ngModel)]="filterSeguradora"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let seguradora of seguradoras" [value]="seguradora">
            {{ seguradora }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterResponsavel">Responsável atual</label>
        <select
          id="filterResponsavel"
          class="form-control"
          [(ngModel)]="filterResponsavel"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let responsavel of responsaveis" [value]="responsavel">
            {{ responsavel }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterStatus">Status</label>
        <select
          id="filterStatus"
          class="form-control"
          [(ngModel)]="filterStatus"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option value="EM_ANDAMENTO">Em andamento</option>
          <option value="CONCLUIDO">Finalizado</option>
          <option value="ATRASADO">Atrasado</option>
        </select>
      </div>
    </div>
  </div>

  <div class="report-kpis">
    <div class="kpi-card">
      <div class="kpi-label">Total de OS</div>
      <div class="kpi-value">{{ total }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Entregues no prazo</div>
      <div class="kpi-value">{{ entreguesNoPrazo }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Entregues com atraso</div>
      <div class="kpi-value">{{ entreguesAtraso }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">% no prazo</div>
      <div class="kpi-value">{{ percentNoPrazo | number: '1.0-1' }}%</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Atraso médio (dias)</div>
      <div class="kpi-value">{{ atrasoMedio }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Lead time médio (dias)</div>
      <div class="kpi-value">{{ leadTimeMedio }}</div>
    </div>
  </div>

  <div class="tabs-pill report-tabs" role="tablist">
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'gargalos'"
      (click)="activeTab = 'gargalos'"
    >
      Top gargalos
    </button>
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'lista'"
      (click)="activeTab = 'lista'"
    >
      Lista operacional
    </button>
  </div>

  <div class="panel report-table" *ngIf="activeTab === 'gargalos'">
    <h2 class="section-title">Top gargalos</h2>
    <div class="wf-table-card">
      <table class="wf-table">
        <thead>
          <tr>
            <th>Etapa</th>
            <th class="col-count">WIP</th>
            <th class="col-count">Em atraso</th>
            <th class="col-days">Atraso médio (dias)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of gargalos">
            <td>{{ item.etapa }}</td>
            <td class="col-count">{{ item.wip }}</td>
            <td class="col-count">{{ item.atrasados }}</td>
            <td class="col-days">{{ item.atrasoMedio }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="panel report-table" *ngIf="activeTab === 'lista'">
    <h2 class="section-title">Lista operacional</h2>
    <div class="wf-table-card">
      <table class="wf-table">
        <thead>
          <tr>
            <th class="col-number">Número OS</th>
            <th>Placa / Veículo</th>
            <th class="col-user">Seguradora</th>
            <th class="col-stage">Etapa atual</th>
            <th class="col-user">Responsável</th>
            <th class="col-date">Data Início</th>
            <th class="col-date">Final Prevista</th>
            <th class="col-date">Final Real</th>
            <th class="col-status">Status SLA</th>
            <th class="col-days">Atraso (dias)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tableItems">
            <td class="col-number">{{ formatOsNumero(item) }}</td>
            <td>{{ item.placa }} - {{ item.marca }} {{ item.modelo }}</td>
            <td class="col-user">{{ item.seguradoraNome || '—' }}</td>
            <td class="col-stage">{{ getEtapaAtualLabel(item) }}</td>
            <td class="col-user">{{ item.responsavelAtual || '—' }}</td>
            <td class="col-date">{{ getDataInicio(item) | date: 'dd/MM/yyyy' }}</td>
            <td class="col-date">
              {{
                getDataFinalPrevista(item) ? (getDataFinalPrevista(item) | date: 'dd/MM/yyyy') : '—'
              }}
            </td>
            <td class="col-date">
              {{ getDataFinalReal(item) ? (getDataFinalReal(item) | date: 'dd/MM/yyyy') : '—' }}
            </td>
            <td class="col-status">{{ getStatusSla(item) }}</td>
            <td class="col-days">{{ getAtrasoDias(item) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
